import React from 'react';
import email from '../../components/email.json';
import pixImg from '../../images/pix.gif';
import moment from 'moment';

const date = moment().format('dddd MMMM D YYYY h:m:s A');

export default class ErrorTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      detail: this.props.detail
    };
  }

  render() {
    return (
      <main>
        <div id='optinMiddle' className='content'>
          <div className='errorMessageContent'>
            <img className='errorIcon' src={pixImg} alt='Error' />
            <p>
              {email.error.ui.text1.eng}
              {email.error.ui.text1.phone.eng}
            </p>
            <div className='errorMessageText'>
              <div>
                <div className='errorLabel'>
                  <strong>{email.error.ui.text2.time.eng} </strong>
                </div>
                <div className='errorInput'>
                  <span htmlescape='false'>
                    {date} {new Date().toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2]}
                  </span>
                </div>
              </div>
              <div>
                <div className='errorLabel'>
                  <span>{email.error.ui.text3.ticket.eng}</span>
                </div>
                <div className='errorInput'>
                  <span htmlescape='false'>{this.state.detail}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }
}
